import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React from 'react';
import { useField } from './hooks/use-field';
import { isFunction } from 'lodash';

function Field(_ref) {
  var id = _ref.id,
      name = _ref.name,
      initialValue = _ref.initialValue,
      sendImmediate = _ref.sendImmediate,
      validate = _ref.validate,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      children = _ref.children,
      render = _ref.render,
      _ref$Component = _ref.Component,
      InputComponent = _ref$Component === void 0 ? 'input' : _ref$Component;

  var _useField = useField(name, {
    id: id,
    initialValue: initialValue,
    sendImmediate: sendImmediate,
    validate: validate,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur
  }),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      actions = _useField2[2];

  var props = {
    field: field,
    meta: meta,
    actions: actions
  };
  return isFunction(children) ? children(props) : isFunction(render) ? render(props) : isFunction(InputComponent) ? /*#__PURE__*/React.createElement(InputComponent, props) : InputComponent ? /*#__PURE__*/React.createElement(InputComponent, field) : null;
}

export default /*#__PURE__*/React.memo(Field);